module.exports = __webpack_public_path__ + "cc-icon_favicon.c1b87fc8.png";